export var SMALL_HEIGHT_DISPLAY = '938px';
export var MAX_MOBILE_WIDTH = '767px';
export var MAX_TABLET_WIDTH = '992px';
export var MIN_TABLET_DESKTOP_WIDTH = '768px';
export var SPLITTER = ';,;';
export var TYPE = 'type';
export var BASE_SINGLE_SELECT_PROPS = {
  styles: {
    container: function container() {
      return {};
    },
    control: function control() {
      return {};
    },
    valueContainer: function valueContainer() {
      return {};
    },
    singleValue: function singleValue() {
      return {};
    },
    dropdownIndicator: function dropdownIndicator() {
      return {};
    },
    option: function option() {
      return {};
    },
    menu: function menu() {
      return {};
    },
    menuList: function menuList() {
      return {};
    }
  },
  components: {
    IndicatorSeparator: null
  },
  isSearchable: false,
  classNamePrefix: 'select-dropdown'
};